import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ToastMessagesService } from 'src/app/core/services/toast-messages.service';
import { AppValidators } from 'src/app/core/validators/app-validators';
import { ActiviteDto } from '../../models/association-membre-activite-dto';
import { ActiviteMembreService } from '../../services/activite-membre.service';

@Component({
  selector: 'app-saisie-activite',
  templateUrl: './saisie-activite.component.html',
  styleUrls: ['./saisie-activite.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SaisieActiviteComponent implements OnInit {
  form: FormGroup;
  saving = false;
  @Output() newActiviteId = new EventEmitter<number>();

  constructor(
    private fb: FormBuilder,
    private toastMessagesService: ToastMessagesService,
    private activiteMembreService: ActiviteMembreService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      id: null,
      codeAnalytique: ['', [Validators.required, AppValidators.codeAnalytique]],
      nomComptable: [null, [Validators.required]],
    });
  }

  save() {
    if (this.form.valid) {
      this.saving = true;
      this.activiteMembreService
        .saveActivite(this.form.getRawValue())
        .pipe(finalize(() => (this.saving = false)))
        .subscribe((r) => {
          this.onSaveSuccess(r);
        });
    }
  }

  onSaveSuccess(reponse) {
    const activiteDto = reponse['activiteDto'] as ActiviteDto;
    this.toastMessagesService.showSuccess('Activité enregistrée');
    this.newActiviteId.emit(activiteDto.id);
    this.form.reset();
  }
}
